import { subject, Unsubscribe } from "@casl/ability";
import { Callout, Text, ChoiceGroup, CommandBar, DefaultButton, Dialog, DialogFooter, DialogType, FontIcon, FontWeights, IButtonProps, IChoiceGroup, IChoiceGroupOption, IChoiceGroupOptionProps, ICommandBarItemProps, ICommandBarStyles, IconButton, IContextualMenuItem, IDialogContentProps, IModalProps, IModalStyles, IRenderFunction, mergeStyleSets, MessageBar, MessageBarType, PrimaryButton, Shimmer, ShimmerElementsGroup, ShimmerElementType, TooltipHost } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios, { CancelTokenSource } from 'axios';
import { ToastMessageType } from 'primereact/toast';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { myTheme } from "../../../assets/styles/my-theme";
import { checkRoles } from '../../../hoc/CheckRoles';
import areaDiLavoroService from '../../../services/areaDiLavoro.service';
import exhibitionsService from '../../../services/exhibitions.service';
import pecmailService from '../../../services/pecmail.service';
import peripheralService from "../../../services/peripheral.service";
import protocolsService from '../../../services/protocols.service';
import protocolsEFService from "../../../services/protocolsEF.service";
import richiesteAnnullamentoService from "../../../services/richiesteAnnullamento.service";
import teamsService from '../../../services/teams.service';
import usersService from '../../../services/users.service';
import abilityBuild from '../../../shared/CASL/appAbility';
import { Indici_FormMode, ProtocolloAreaDiLavoroEF_Priority, ProtocolloAreaDiLavoroEF_State, Protocol_State, Protocol_Type, RichiestaAnnullamento_Status, RichiestaAnnullamento_Status_Label, RoleContext, Visibilita_ViewMode, Visibility_Type } from '../../../shared/enums';
import { IAoo, IArubaRemoteSignRequest, IField, IFile, IProtocol, IProtocolEF, IProtocolloAreaDiLavoro, IProtocolReference, IRichiestaAnnullamento, ISendMailRequest, IUor, IVisibilita } from '../../../shared/interfaces';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import Utilities from '../../../shared/Utilities/utilities';
import { reduxActions, RootState } from '../../../store';
import CustomCommandBarButton from '../../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import FilingPlanTree from '../../FilingPlan/FilingPlanTree';
import { toastRef } from '../../Layout/Layout';
import RippleLoader from '../../Loader/RippleLoader/RippleLoader';
import PdfViewer from '../../PdfViewer/PdfViewer';
import PrintLabel from "../ProtocolWizard/UploadFiles/PrintLabel/PrintLabel";
import Visibilita from '../Visibilita/Visibilita';
import AddFascicoliDiProtocolloPanel from './AddFascicoliDiProtocolloPanel/AddFascicoliDiProtocolloPanel';
import AddProtocolReferencesPanel from './AddProtocolReferences/AddProtocolReferencesPanel';
import Allegati from './DetailsViewer/Allegati/Allegati';
import Annotazioni from './DetailsViewer/Annotazioni/Annotazioni';
import FascicoliDiProtocollo from './DetailsViewer/FascicoliDiProtocollo/FascicoliDiProtocollo';
import Indici from './DetailsViewer/Indici/Indici';
import SEI from './DetailsViewer/PrintAndSend/SEI';
import ProtocolReferences from './DetailsViewer/ProtocolReferences/ProtocolReferences';
import Spedizioni from './DetailsViewer/Spedizioni/Spedizioni';
import Storia from './DetailsViewer/Storia/Storia';
import Versioni from './DetailsViewer/Versioni/Versioni';
import classes from './ProtocolViewer.module.scss';
import RemoteSignPanel from './RemoteSign/RemoteSignPanel';
import SendMailPanel from './SendMail/SendMailPanel';
import UndoRequestPanel from "./UndoRequestPanel/UndoRequestPanel";


const queryString = require('query-string');

const { palette } = myTheme;

const styles = mergeStyleSets({
    button: {
        width: 300,
        marginTop: 20,
        marginBottom: 0,
        marginLeft: 20,
        borderWidth: 1,
        borderColor: `${palette.themePrimary}`
    },
    callout: {
        width: 320,
        maxWidth: '90%',
        padding: '20px 24px',
    },
    title: {
        marginBottom: 12,
        fontWeight: FontWeights.semilight,
    },
    link: {
        display: 'block',
        marginTop: 20,
    },
});

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: [], // CommandBar will determine items rendered in overflow
        isBeakVisible: true,
        beakWidth: 20,
        gapSpace: 10,
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 14px', borderBottom: '1px solid #eee' }
};

const pivotBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 14px' }
};


const modalStyles: Partial<IModalStyles> = {
    main: {
        '@media(min-width: 480px)': {
            width: '100%',
            maxWidth: 400
        }
    }
}

const modalProps: IModalProps = {
    isBlocking: false,
    styles: modalStyles,
};

const commandBarOverflowItems: ICommandBarItemProps[] = [];
const commandBarFarItems: ICommandBarItemProps[] = [];

const documentPivotBarDefaultItems: ICommandBarItemProps[] = [
    {
        key: 'documento',
        text: 'Documento',
    }
];

//  NotFound nel base64 produrrà Anteprima non disponibile in PdfViewer
const errorFile = { docBase64String: 'NotFound', fileName: '' };


const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUor: state.sessionReducer.currentUor,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
    isMobile: state.sessionReducer.isMobile,
})
const mapDispatch = {
    setProtocol: (protocol?: IProtocol) => (reduxActions.appNavigationActions.setProtocol(protocol)),
    unsetProtocol: () => (reduxActions.appNavigationActions.unsetProtocol()),
    updateSession: (session) => (reduxActions.sessionActions.updateSession(session)),
    resetPrintAndSendFields: () => (reduxActions.printAndSendWizardActions.resetPrintAndSendFields()),
}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface ProtocolViewerProps {

}

export interface ProtocolViewerState {
    currentProtocol: IProtocol | undefined,
    currentProtocolloAreaDiLavoro: IProtocolloAreaDiLavoro | undefined,
    commandBarItems: ICommandBarItemProps[],
    documentPivotBarItems: ICommandBarItemProps[],
    documentPivotBarSelectedKey: string,
    detailsPivotBarItems: ICommandBarItemProps[],
    detailsPivotBarSelectedKey: string,
    allegatoBase64String: string | undefined
    allegatoName: string,
    sendMailPanelIsOpen: boolean,
    remoteSignPanelIsOpen: boolean,
    addProtocolReferencesPanelIsOpen: boolean,
    addToFascicoloPanelIsOpen: boolean,
    undoRequestPanelIsOpen: boolean,
    showIndexesLoader: boolean,
    showActionsLoader: boolean,
    showMessageBar: boolean
    messageBarType: MessageBarType,
    messageBarText: string
    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogSubmitFunction: Function,
    confirmDialogDismissFunction: Function,
    selectUorDialogIsOpen: boolean,
    selectUorChoiceGroupOptions: IChoiceGroupOption[],
    protocolFormMode: Indici_FormMode,
    selectedFilingPlanKey?: string,
    selectedVisibilita?: IVisibilita[],
    selectedProtocolReference?: IProtocolReference,
    forceSpedizioniRefresh: boolean,
    forceProtocolReferencesRefresh: boolean,
    forceFascicoliRefresh: boolean,
    titolarioRequired: boolean,
    titolarioTouched: boolean,
    titolarioValid: boolean,
    indiciTouched: boolean,
    isCalloutVisible: boolean,
    currentProtocolEF: IProtocolEF | undefined,
    currentProtocolUndoRequests: IRichiestaAnnullamento[]
    selectedPrinterName: string | undefined
}

type Props = ProtocolViewerProps & RouteComponentProps & PropsFromRedux

class ProtocolViewer extends React.Component<Props, ProtocolViewerState> {

    uploadInputRef = React.createRef<HTMLInputElement>();
    choiceGroupRef = React.createRef<IChoiceGroup>();
    filingPlanTreeRef = React.createRef();

    unsubscribeFromAbility: Unsubscribe = () => { };

    state: ProtocolViewerState = {
        currentProtocol: {
            documentFile: { docBase64String: undefined, fileName: '' }
        },
        currentProtocolloAreaDiLavoro: undefined,
        // uso l’operatore .slice() per creare una copia di defaultCommandBarItem altrimenti avrei un riferimento a defaultCommandBarItem
        commandBarItems: [],
        documentPivotBarItems: documentPivotBarDefaultItems.slice(),
        documentPivotBarSelectedKey: 'documento',
        detailsPivotBarItems: [],
        detailsPivotBarSelectedKey: 'indici',
        allegatoBase64String: undefined,
        allegatoName: '',
        sendMailPanelIsOpen: false,
        remoteSignPanelIsOpen: false,
        addProtocolReferencesPanelIsOpen: false,
        addToFascicoloPanelIsOpen: false,
        undoRequestPanelIsOpen: false,
        showIndexesLoader: false,
        showActionsLoader: false,
        showMessageBar: false,
        messageBarType: MessageBarType.info,
        messageBarText: "",
        confirmDialogIsOpen: false,
        confirmDialogContentProps: {},
        confirmDialogSubmitFunction: () => { },
        confirmDialogDismissFunction: () => { this.dismissConfirmDialog() },
        selectUorDialogIsOpen: false,
        selectUorChoiceGroupOptions: [],
        protocolFormMode: Indici_FormMode.Undefined,
        forceSpedizioniRefresh: false,
        forceProtocolReferencesRefresh: false,
        forceFascicoliRefresh: false,
        titolarioRequired: false,
        titolarioTouched: false,
        titolarioValid: true,
        indiciTouched: false,
        isCalloutVisible: false,
        currentProtocolEF: undefined,
        currentProtocolUndoRequests: [],
        selectedPrinterName: undefined
    }

    cancelTokenSources = {};

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            this.updateCommandBarItems();
        });

        this.checkProtocolAccess();
        if (this.props.currentAoo && this.props.currentUor && this.state.currentProtocol) {
            this.getProtocolEFWithAreaDiLavoroAndUndoRequests(this.props.currentAoo.id, this.props.currentUor.id!, this.state.currentProtocol.id!);
        }
    }


    componentDidUpdate(oldProps: Props, oldState: ProtocolViewerState) {
        if (this.props.currentAoo !== oldProps.currentAoo || this.props.location !== oldProps.location) {
            this.checkProtocolAccess();
        }

        if (this.props.location !== oldProps.location) {
            this.setState({
                documentPivotBarItems: documentPivotBarDefaultItems.slice(),
                documentPivotBarSelectedKey: 'documento',
                detailsPivotBarSelectedKey: 'indici',
                currentProtocol: {
                    documentFile: { docBase64String: undefined, fileName: '' }
                },

            }, this.updateDocumentAndDetailsPivotBarItems);
        }

        if (this.props.isMobile && oldProps.isMobile !== this.props.isMobile) {
            this.updateDocumentAndDetailsPivotBarItems();
        }

        if (oldState.currentProtocol !== this.state.currentProtocol) {
            this.props.setProtocol(this.state.currentProtocol);
            this.props.resetPrintAndSendFields();
            //if (this.props.currentAoo && this.props.currentUor && this.state.currentProtocol) {
            //    this.getProtocolEFWithAreaDiLavoroAndUndoRequests(this.props.currentAoo.id, this.props.currentUor.id!, this.state.currentProtocol.id!);
            //}

        }

        if (oldState.protocolFormMode !== this.state.protocolFormMode) {
            this.updateCommandBarItems();
        }
    }

    componentWillUnmount() {
        this.props.unsetProtocol();
        this.unsubscribeFromAbility();
        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
    }


    checkProtocolAccess = () => {
        if (this.props.currentAoo) {
            let { currentAoo, currentUser, match, location, history } = this.props;
            const parsedQueryString = queryString.parse(this.props.location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getUserVisibilitaForProtocol.name]?.cancel(protocolsService.getUserVisibilitaForProtocol.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getUserVisibilitaForProtocol.name] = axios.CancelToken.source();

            /// faccio get visibilità
            /// se nell'url c'è il parametro uorId che specifica con quale uor accedere al protocollo
            ///     la uor che sto navigando è in visibilità?
            ///      - si: procedo con getprotocol....
            ///      - no: in visibilità c'è almeno una UOR associata a current user?
            ///          - si: rimuovo il parametro uorId dall'url e aggiorno la pagina (lo rimuovo perchè altrimenti nella storia risulta l'accesso tramite uor)
            ///          - no: l'utente corrente è un supervisore?
            ///              - si: rimuovo il parametro uorId dall'url e aggiorno la pagina (lo rimuovo perchè altrimenti nella storia risulta l'accesso tramite uor)
            ///              - no: viene eseguita una redirect alla pagina unauthorized
            /// se nell'url NON c'è il parametro uorId
            ///     se in visibilità c'è una sola UOR, allora viene inserito il parametro uorId nell'url e aggiornata la pagina
            ///     se in visibilità ci sono più UOR, allora viene mostrata la dialog per scegliere con quale UOR accedere
            ///     se in visibilità NON ci sono UOR associate a current user e l'utente corrente è un supervisore, allora procedo con getprotocol....
            ///     altrimeti viene eseguita una redirect alla pagina unauthorized
            protocolsService.getUserVisibilitaForProtocol(currentAoo.id, match.params['id'], this.cancelTokenSources[protocolsService.getUserVisibilitaForProtocol.name].token)
                .then(userVisibilita => {

                    if (uorId) {
                        if (userVisibilita.findIndex(el => el.uor.id === uorId) >= 0) {
                            this.getProtocolAndDocumentBase64String();
                        }
                        else if (userVisibilita.length > 0 || usersService.userIsSupervisore(currentUser!, currentAoo.id)) {
                            let { url } = match;
                            delete parsedQueryString.uorId;
                            const newQueryString = queryString.stringify(parsedQueryString);
                            history.replace({ pathname: url, search: newQueryString });

                        }
                        else {
                            history.push({ pathname: '/unauthorized' });
                        }
                    }
                    else {
                        if (userVisibilita && userVisibilita.length === 1) {
                            let { url } = match;
                            let uorId = userVisibilita[0].uor.id;
                            const parsedQueryString = queryString.parse(location.search);
                            parsedQueryString.uorId = uorId;
                            const newQueryString = queryString.stringify(parsedQueryString);


                            history.replace({ pathname: url, search: newQueryString });
                            toastRef.current?.show({ severity: 'info', summary: 'Cambio UOR', detail: `Sei passato alla UOR: ${userVisibilita[0].uor.nome}`, life: 5000 });

                        }
                        else if (userVisibilita && userVisibilita.length > 1) {
                            let options: IChoiceGroupOption[] = userVisibilita.map((el, index) => {
                                return { key: index.toString(), text: el.uor.nome!, uorId: el.uor.id, tipologia: el.tipologia, onRenderField: this.onRenderSelectUorChoiceGroupItem };
                            });
                            this.setState({ selectUorDialogIsOpen: true, selectUorChoiceGroupOptions: options });
                        }
                        else if (usersService.userIsSupervisore(currentUser!, currentAoo.id)) {
                            this.getProtocolAndDocumentBase64String();
                        }
                        else {
                            history.push({ pathname: '/unauthorized' });
                        }
                    }
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else {
                        throw error;
                    }

                });
        }

    }


    getProtocol(currentAoo: IAoo, uorId: number) {
        // se in cancelTokenSources c'è il cancelToken associato alla chiamata
        // chiamo il metodo cancel che interrompe la chiamata in pending
        this.cancelTokenSources[protocolsService.getProtocol.name]?.cancel(protocolsService.getProtocol.name + " Request annullata");
        // Ricreo il cancel token ad ogni request
        this.cancelTokenSources[protocolsService.getProtocol.name] = axios.CancelToken.source();

        this.setState({ showIndexesLoader: true });

        let protocolId = this.props.match.params['id'];

        protocolsService
            .getProtocol(currentAoo.id, uorId, protocolId, this.cancelTokenSources[protocolsService.getProtocol.name].token)
            .then(protocolResponse => {

                let protocolloSP = { ...protocolResponse };

                if (
                    (abilityBuild.can('use', subject('IFeature', { key: 'AreaDiLavoro', enabled: true }))
                        && abilityBuild.can('read', 'IProtocolloAreaDiLavoro'))
                    || (abilityBuild.can('use', subject('IFeature', { key: 'RichiesteDiAnnullamento', enabled: true })))
                ) {
                    this.getProtocolEFWithAreaDiLavoroAndUndoRequests(currentAoo.id, uorId, protocolId);
                }

                let { fields } = protocolloSP;
                protocolloSP.fields = AppUtilities.fixFieldsInternalValueForClientView(fields);

                let doc: IProtocol = { ...protocolloSP, documentFile: this.state.currentProtocol?.documentFile };

                this.setState({
                    currentProtocol: doc,
                    showIndexesLoader: false,
                }, () => {
                    this.updateCommandBarItems();
                    this.updateDocumentAndDetailsPivotBarItems();
                    this.updateIndiciFormMode(doc);
                });

            })
            .catch(error => {
                this.setState({
                    showIndexesLoader: false
                });

                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else if (!error.isErrorShown) {
                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere gli indici`, life: 5000 });

                } else {
                    throw error;
                }

            });

    }


    getProtocolEFWithAreaDiLavoroAndUndoRequests = (aooId: number, uorId: number, protocolId: number) => {

        protocolsEFService.getProtocolEF(aooId, uorId, protocolId)
            .then(response => {
                let protocolloAreaDiLavoro: IProtocolloAreaDiLavoro = response.areeDiLavoroProtocollo.length > 0 ? {
                    ...response.areeDiLavoroProtocollo[0], protocolEFId: response.id, protocolEF: { ...response }
                } : undefined;
                this.setState({
                    currentProtocolEF: response,
                    currentProtocolUndoRequests: response.richiesteDiAnnullamento,
                    currentProtocolloAreaDiLavoro: protocolloAreaDiLavoro
                }, () => {
                    this.updateCommandBarItems();
                });
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                }
            });
    }

    //getProtocolloAreaDiLavoro(uorId: number, protocolId: string) {

    //    areaDiLavoroService
    //        .getProtocolloAreaDiLavoro(uorId, protocolId)
    //        .then(protocolloAreaDiLavoroResponse => {
    //            if (protocolloAreaDiLavoroResponse) {
    //                let protocolloAreaDiLavoro = { ...protocolloAreaDiLavoroResponse };
    //                this.setState({
    //                    currentProtocolloAreaDiLavoro: protocolloAreaDiLavoro,
    //                }, () => {
    //                    this.updateCommandBarItems();
    //                });
    //            }
    //        })
    //        .catch(error => {
    //            if (axios.isCancel(error)) {
    //                //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
    //                console.log(error.message);
    //            }
    //        });

    //}

    getProtocolBase64String(_currentAoo: IAoo, uorId: number, _currentProtocol: IProtocol) {
        // se in cancelTokenSources c'è il cancelToken associato alla chiamata
        // chiamo il metodo cancel che interrompe la chiamata in pending
        this.cancelTokenSources[protocolsService.getProtocolBase64String.name]?.cancel(protocolsService.getProtocolBase64String.name + " Request annullata");
        // Ricreo il cancel token ad ogni request
        this.cancelTokenSources[protocolsService.getProtocolBase64String.name] = axios.CancelToken.source();

        let doc: IProtocol = { ..._currentProtocol };
        protocolsService.getProtocolBase64String(_currentAoo.id, uorId, this.props.match.params['id'], this.cancelTokenSources[protocolsService.getProtocolBase64String.name].token)
            .then(fileResult => {

                let newDocumentFile: IFile = { ..._currentProtocol.documentFile, docBase64String: fileResult.docBase64String, fileName: fileResult.fileName };
                doc.documentFile = newDocumentFile;
            })
            .catch(error => {
                doc.documentFile = errorFile;
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else if (!error.isErrorShown) {
                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Documento non recuperato`, life: 5000 });

                } else {
                    throw error;
                }

            })
            .finally(() => {
                this.setState({
                    currentProtocol: doc,
                }, () => {
                    this.updateCommandBarItems();
                    this.updateDocumentAndDetailsPivotBarItems();
                    this.updateIndiciFormMode(doc);

                });


            });
    }
    getProtocolAndDocumentBase64String() {
        if (this.props.currentAoo) {
            this.setState({ showIndexesLoader: true });

            let { currentAoo, match, location, history } = this.props;
            const parsedQueryString = queryString.parse(location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getProtocol.name]?.cancel(protocolsService.getProtocol.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getProtocol.name] = axios.CancelToken.source();


            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getProtocolBase64String.name]?.cancel(protocolsService.getProtocolBase64String.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getProtocolBase64String.name] = axios.CancelToken.source();


            let doc: IProtocol = {};
            const getProtocol = protocolsService
                .getProtocol(currentAoo.id, uorId, match.params['id'], this.cancelTokenSources[protocolsService.getProtocol.name].token);


            const getProtocolBase64String = protocolsService
                .getProtocolBase64String(currentAoo.id, uorId, match.params['id'], this.cancelTokenSources[protocolsService.getProtocolBase64String.name].token)
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    else if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Documento non recuperato`, life: 5000 });
                    } else {
                        throw error;
                    }
                });



            let _titolarioRequired = false;
            let _selectedFilingPlanKey = undefined;

            axios.all([getProtocol, getProtocolBase64String])
                .then(axios.spread((protocolResponse, documentFileResponse) => {

                    let newProtocol = { ...protocolResponse };
                    let newDocumentFile = documentFileResponse ? { ...documentFileResponse } : errorFile;

                    if (newProtocol) {

                        let { fields } = newProtocol;
                        newProtocol.fields = AppUtilities.fixFieldsInternalValueForClientView(fields);

                        let titolarioField = fields.find(el => el.internalName === 'Titolario');
                        _titolarioRequired = titolarioField ? titolarioField.required : false;
                        _selectedFilingPlanKey = newProtocol.titolario;

                    }
                    doc = { ...newProtocol, documentFile: newDocumentFile };

                }))
                .catch(error => {
                    doc.documentFile = errorFile;
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    else if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Documento non recuperato`, life: 5000 });
                    }
                    else {
                        throw error;
                    }

                })
                .finally(() => {
                    this.setState({
                        currentProtocol: doc,
                        showIndexesLoader: false,
                        selectedFilingPlanKey: _selectedFilingPlanKey,
                        titolarioRequired: _titolarioRequired,
                        titolarioTouched: false,
                        indiciTouched: false
                    }, () => {
                        this.updateCommandBarItems();
                        this.updateDocumentAndDetailsPivotBarItems();
                        this.updateIndiciFormMode(doc);

                    });


                });
            if (abilityBuild.can('use', subject('IFeature', { key: 'AreaDiLavoro', enabled: true }))
                && abilityBuild.can('read', 'IProtocolloAreaDiLavoro')) {
                this.getProtocolEFWithAreaDiLavoroAndUndoRequests(currentAoo.id ?? 0, uorId ?? 0, match.params['id']);
            }

        }
    }

    // Click sul button della commandbar
    salvaIndiciHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (this.state.currentProtocol) {
            let { statoProtocollo, titolario } = this.state.currentProtocol;

            if (this.checkProtocolValidity(statoProtocollo, titolario, true, false)) {

                this.setState({
                    confirmDialogIsOpen: false,
                    showMessageBar: false,
                    showIndexesLoader: true
                });

                this.salvaIndiciSubmit();
            }
        }
    }
    salvaIndiciSubmit = () => {
        const parsedQueryString = queryString.parse(this.props.location.search);
        if (this.state.currentProtocol) {
            let { id, fields } = this.state.currentProtocol;

            if (this.props.currentAoo && parsedQueryString.uorId && id && fields) {

                let { currentAoo } = this.props;
                let fixedFields = AppUtilities.fixFieldsInternalValueForCreateAndUpdateProtocol(fields, false);

                let touchedFields = fixedFields.filter(el => el.touched);

                let uorId: number = Number(parsedQueryString.uorId);

                protocolsService
                    .updateProtocol(currentAoo.id, uorId, id, touchedFields)
                    .then(result => {

                        toastRef.current?.show({ severity: 'info', summary: 'Info', detail: `Documento salvato`, life: 5000 });
                        this.setState({ showIndexesLoader: false, indiciTouched: false });
                        this.getProtocol(currentAoo, uorId);
                    },
                        error => {
                            if (!error.isErrorShown) {
                                this.setState({
                                    showIndexesLoader: false,
                                    showMessageBar: true,
                                    messageBarType: MessageBarType.error,
                                    messageBarText: 'Errore nel salvataggio'
                                })
                                toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Protocollazione non riuscita`, life: 5000 });
                            }
                            else {
                                this.setState({ showIndexesLoader: false });
                            }
                        });

            }
        }
    }
    // Click sul button della commandbar
    createProtocolFromHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (this.props.currentAoo && this.state.currentProtocol && this.state.currentProtocol.id) {
            let protId = this.state.currentProtocol.id;

            let path = `/${this.props.currentAoo.id}/createfrom/${protId}`;
            this.navigate(path);

        }

    }
    // Click sul button della commandbar
    addAreaLavoroHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        let { currentProtocol, currentProtocolloAreaDiLavoro } = this.state;
        let { currentUor } = this.props;

        if (currentProtocol && currentUor) {
            let newItemAreaDiLavoro: Partial<IProtocolloAreaDiLavoro> = {
                uorId: currentUor!.id!,
                statoLavorazione: ProtocolloAreaDiLavoroEF_State.DaLeggere,
                priorita: ProtocolloAreaDiLavoroEF_Priority.Media,

            };
            this.setState({ showActionsLoader: true });

            //aggiunge gli zeri prima del numero
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = `${zeroPad(currentProtocol?.numeroProtocollo, 8)}-${currentProtocol?.annoProtocollo}`;

            if (currentProtocolloAreaDiLavoro && currentProtocolloAreaDiLavoro.statoLavorazione !== ProtocolloAreaDiLavoroEF_State.Lavorato) {
                this.setState({
                    showActionsLoader: false,
                })
                toastRef.current?.show({ severity: 'warn', summary: 'Attenzione', detail: `Il protocollo ${protocolnumber} è già presente nell'area di lavoro`, life: 5000 });

            }
            else if (currentProtocolloAreaDiLavoro && currentProtocolloAreaDiLavoro.statoLavorazione === ProtocolloAreaDiLavoroEF_State.Lavorato) {
                this.setState({
                    showActionsLoader: false,
                    confirmDialogIsOpen: true,
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Attenzione',
                        closeButtonAriaLabel: 'Close',
                        subText: `Il protocollo è già stato lavorato dalla UOR ${currentUor?.nome}, ripristinare la lavorazione?`,
                    },
                    confirmDialogSubmitFunction: () => { this.ripristinaLavorazioneProtocolloAreaDiLavoroSumbit(currentProtocolloAreaDiLavoro!) }

                })

            }
            else {
                areaDiLavoroService.addProtocolloAreaDiLavoro(currentProtocol?.id!, newItemAreaDiLavoro)
                    .then(newSelectedProtocolAreaDiLavoro => {
                        this.setState({ showActionsLoader: false, currentProtocolloAreaDiLavoro: newSelectedProtocolAreaDiLavoro }, this.updateCommandBarItems);
                        toastRef.current?.show({ severity: 'info', summary: 'Operazione completata', detail: `Il protocollo ${protocolnumber} è stato aggiunto all'area di lavoro`, life: 5000 });
                    })
                    .catch(error => {
                        this.setState({ showActionsLoader: false });
                        if (!error.isErrorShown) {
                            toastRef.current?.show({ severity: 'error', summary: "Attenzione", detail: `Aggiornamento area di lavoro non riuscito`, life: 5000 });
                        }
                    });
            }


        }
    }
    ripristinaLavorazioneProtocolloAreaDiLavoroSumbit = (protocolloAreaDiLavoro: IProtocolloAreaDiLavoro) => {

        //aggiunge gli zeri prima del numero
        let { currentProtocol } = this.state;
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        let protocolnumber = `${zeroPad(currentProtocol?.numeroProtocollo, 8)}-${currentProtocol?.annoProtocollo}`;

        this.setState({ showActionsLoader: true, confirmDialogIsOpen: false });
        areaDiLavoroService.ripristinaLavorazione(protocolloAreaDiLavoro)
            .then(newSelectedProtocolAreaDiLavoro => {
                this.setState({ showActionsLoader: false, currentProtocolloAreaDiLavoro: newSelectedProtocolAreaDiLavoro }, this.updateCommandBarItems);
                toastRef.current?.show({ severity: 'info', summary: 'Operazione completata', detail: `Il protocollo ${protocolnumber} è stato aggiunto all'area di lavoro`, life: 5000 });
            })
            .catch(error => {
                this.setState({ showActionsLoader: false });
                if (!error.isErrorShown) {
                    toastRef.current?.show({ severity: 'error', summary: "Attenzione", detail: `Aggiornamento area di lavoro non riuscito`, life: 5000 });
                }
            });

    }

    // Click sul button della commandbar
    onAvviaLavorzioneClick = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi avviare la lavorazione del protocollo?',
                children: undefined
            },
            confirmDialogSubmitFunction: () => { this.onAvviaLavorazioneEPendiInCaricoConfirmDialogSubmit() }

        })
    }

    // Click su conferma del confirm dialog
    onAvviaLavorazioneEPendiInCaricoConfirmDialogSubmit = () => {
        this.setState({
            confirmDialogIsOpen: false,
        });
        let { currentProtocol, currentProtocolloAreaDiLavoro } = this.state
        if (currentProtocolloAreaDiLavoro) {
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = `${zeroPad(currentProtocol?.numeroProtocollo, 8)}-${currentProtocol?.annoProtocollo}`;


            areaDiLavoroService.avviaLavorazioneEPendiInCarico(currentProtocolloAreaDiLavoro)
                .then((newSelectedProtocolAreaDiLavoro) => {

                    this.setState({ showActionsLoader: false, currentProtocolloAreaDiLavoro: newSelectedProtocolAreaDiLavoro }, this.updateCommandBarItems);
                    toastRef.current?.show({ severity: 'info', summary: 'Operazione completata', detail: `Lavorazione del protocollo ${protocolnumber} avviata`, life: 5000 });

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Aggiornamento non riuscito`, life: 5000 });
                    }
                });

        }
    }

    // Click sul button della commandbar
    onTerminaLavorzioneClick = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi terminare la lavorazione del protocollo?',
                children: undefined
            },
            confirmDialogSubmitFunction: () => { this.onTerminaLavorzioneConfirmDialogSubmit() }

        })
    }

    // Click su conferma del confirm dialog
    onTerminaLavorzioneConfirmDialogSubmit = () => {
        this.setState({
            confirmDialogIsOpen: false,
        });
        let { currentProtocol, currentProtocolloAreaDiLavoro } = this.state
        if (currentProtocolloAreaDiLavoro) {
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = `${zeroPad(currentProtocol?.numeroProtocollo, 8)}-${currentProtocol?.annoProtocollo}`;



            this.setState({ showActionsLoader: true, confirmDialogIsOpen: false });
            areaDiLavoroService.terminaLavorazione(currentProtocolloAreaDiLavoro)
                .then(newSelectedProtocolAreaDiLavoro => {
                    this.setState({ showActionsLoader: false, currentProtocolloAreaDiLavoro: newSelectedProtocolAreaDiLavoro }, this.updateCommandBarItems);
                    toastRef.current?.show({ severity: 'info', summary: 'Operazione completata', detail: `Lavorazione del protocollo ${protocolnumber} terminata`, life: 5000 });
                    let path = `/${this.props.currentAoo!.id}`;
                    this.navigate(path);
                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: "Attenzione", detail: `Aggiornamento area di lavoro non riuscito`, life: 5000 });
                    }
                });

        }
    }
    // Click sul button della commandbar
    reloadProtocolHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (this.props.currentAoo && this.state.currentProtocol && this.state.currentProtocol.id) {
            let protId = this.state.currentProtocol.id;

            let path = `/${this.props.currentAoo.id}/reload/${protId}`;
            this.navigate(path);

        }

    }
    // Click sul button della commandbar
    editIndexesProtocolHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        this.setState({ protocolFormMode: Indici_FormMode.Edit, showIndexesLoader: true });
        setTimeout(() => {
            this.setState({ showIndexesLoader: false })
        }, 800);
    }

    // Click sul button della commandbar
    undoEditIndexesProtocolHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();


        const parsedQueryString = queryString.parse(this.props.location.search);
        if (this.props.currentAoo && parsedQueryString.uorId) {
            let _currentAoo = this.props.currentAoo
            let uorId: number = Number(parsedQueryString.uorId);

            this.getProtocol(_currentAoo, uorId);
        }
    }

    // Click sul button della commandbar
    protocollaDocumentoHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        let { currentProtocol } = this.state;

        if (currentProtocol && currentProtocol.statoProtocollo === Protocol_State.Acquisito) {
            let path = `/${this.props.currentAoo!.id}/acquired/${currentProtocol.id}/${currentProtocol.numeroProtocollo}`;
            this.navigate(path);
        } else if (currentProtocol && currentProtocol.statoProtocollo === Protocol_State.Allocato) {
            let path = `/${this.props.currentAoo!.id}/allocated/${currentProtocol.id}/${currentProtocol.numeroProtocollo}`;
            this.navigate(path);
        }
    }


    // Click sul button della commandbar

    annullaProtocolloHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        // se è attiva la feature per la richiesta di annullamento apro il panel, altrimenti la dialog di conferma
        if (abilityBuild.can('use', subject('IFeature', { key: 'RichiesteDiAnnullamento', enabled: true }))) {

            this.setState({ undoRequestPanelIsOpen: true });
        } else {
            this.setState({
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: 'Vuoi annullare il protocollo?',
                },
                confirmDialogSubmitFunction: () => { this.annullaProtocolloConfirmDialogSubmit() }

            })
        }
    }


    undoRequestPanelSubmit = () => {
        this.setState({ undoRequestPanelIsOpen: false });
        toastRef.current?.show({
            severity: 'info',
            summary: 'Richiesta annullamento inviata',
            detail: `È stato richiesto l'annullamento del protocollo ${this.state.currentProtocol?.numeroProtocollo}`,
            life: 5000
        });
        this.getProtocolAndDocumentBase64String();

    }

    undoRequestPanelSDismiss = () => {
        this.setState({ undoRequestPanelIsOpen: false });
    }

    // Click su conferma del confirm dialog
    annullaProtocolloConfirmDialogSubmit = () => {
        const parsedQueryString = queryString.parse(this.props.location.search);
        if (this.props.currentAoo && parsedQueryString.uorId && this.state.currentProtocol && this.state.currentProtocol.id) {
            this.setState({ confirmDialogIsOpen: false, showActionsLoader: true });
            //aggiunge gli zeri prima del numero
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = `${zeroPad(this.state.currentProtocol?.numeroProtocollo, 8)}-${this.state.currentProtocol?.annoProtocollo}`;

            let uorId: number = Number(parsedQueryString.uorId);

            protocolsService
                .undoProtocol(this.props.currentAoo.id, uorId, this.state.currentProtocol.id)
                .then(result => {
                    this.setState({ showActionsLoader: false });
                    toastRef.current?.show({ severity: 'info', summary: 'Annullato', detail: `Il protocollo ${protocolnumber} è stato annullato`, life: 5000 });
                    this.getProtocolAndDocumentBase64String();
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Annullamento non riuscito`, life: 5000 });
                    }
                    this.setState({
                        showActionsLoader: false,

                    })
                });
        }
    }


    // Click sul button della commandbar
    creaCanaleTeamsHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi creare un nuovo canale Teams?',
            },
            confirmDialogSubmitFunction: () => { this.creaCanaleTeamsConfirmDialogSubmit() }

        })
    }
    // Click su conferma del confirm dialog
    creaCanaleTeamsConfirmDialogSubmit = () => {
        this.setState({ confirmDialogIsOpen: false })
        //aggiunge gli zeri prima del numero
        const zeroPad = (num, places) => String(num).padStart(places, '0');

        let protocolnumber = `${zeroPad(this.state.currentProtocol?.numeroProtocollo, 8)}-${this.state.currentProtocol?.annoProtocollo}`;

        let channelName = `Protocollo ${protocolnumber}`;

        teamsService.createChannel(channelName)
            .then(result => {
            })
            .finally(() => {
                this.setState({ showActionsLoader: false });
            });
    }

    // Click sul button della commandbar
    archiviaProtocolloHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi archiviare il protocollo?',
            },
            confirmDialogSubmitFunction: () => { this.archiviaProtocolloConfirmDialogSubmit() }

        })
    }
    // Click su conferma del confirm dialog
    archiviaProtocolloConfirmDialogSubmit = () => {
        this.setState({ confirmDialogIsOpen: false })
    }


    // Click sul button della commandbar
    salvaVisibilitaHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi salvare la visibilità?',
            },
            confirmDialogSubmitFunction: () => { this.salvaVisibilitaConfirmDialogSubmit() }

        })
    }
    // Click su conferma del confirm dialog
    salvaVisibilitaConfirmDialogSubmit = () => {
        this.setState({ confirmDialogIsOpen: false, showActionsLoader: true });
        if (this.props.currentAoo && this.state.currentProtocol) {
            let { currentProtocol } = this.state
            let { currentAoo, location } = this.props

            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            protocolsService.updateVisibilitaProtocol(currentAoo.id, uorId, currentProtocol.id!, this.state.selectedVisibilita!)
                .then(result => {
                    this.getProtocolAndDocumentBase64String();
                    this.setState({ showActionsLoader: false });
                    toastRef.current?.show({ severity: 'info', summary: 'Aggiornamento', detail: `Visibilità aggiornata correttamente`, life: 5000 });
                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Visibilità non aggiornata`, life: 5000 });
                    }
                });

        }
    }
    // Click sul button della commandbar
    salvaTitolarioHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (this.state.currentProtocol) {
            let { currentProtocol } = this.state

            if (this.checkProtocolValidity(currentProtocol.statoProtocollo, this.state.selectedFilingPlanKey, false, true)) {

                this.setState({
                    confirmDialogIsOpen: true,
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: 'Vuoi salvare il Titolario?',
                    },
                    confirmDialogSubmitFunction: () => { this.salvaTitolarioConfirmDialogSubmit() }

                })
            }
        }
    }
    // Click su conferma del confirm dialog
    salvaTitolarioConfirmDialogSubmit = () => {
        this.setState({ confirmDialogIsOpen: false, showActionsLoader: true });
        if (this.props.currentAoo && this.state.currentProtocol) {
            let { currentProtocol } = this.state
            let { currentAoo, location } = this.props

            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            protocolsService.updateFilingPlanProtocol(currentAoo.id, uorId, currentProtocol.id!, this.state.selectedFilingPlanKey)
                .then(result => {
                    this.getProtocolAndDocumentBase64String();
                    this.setState({ showActionsLoader: false });
                    toastRef.current?.show({ severity: 'info', summary: 'Aggiornamento', detail: `Titolario aggiornato correttamente`, life: 5000 });
                    this.setState({ titolarioValid: true, titolarioTouched: false });

                })
                .catch(error => {
                    this.setState({ showActionsLoader: false, titolarioValid: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attenzione', detail: `Titolario non aggiornato`, life: 5000 });
                    }
                });


        }
    }

    // Click sul button della commandbar
    sendMailHandler = (ev: any, item: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ sendMailPanelIsOpen: true });

    }

    // Click su salva del panel laterale
    sendMailLateralPanelSubmit = (mail) => {
        this.setState({ sendMailPanelIsOpen: false, showActionsLoader: true })
        if (this.props.currentAoo && this.state.currentProtocol) {
            // currentProtocol senza allegati
            let { attachments, ...protocol } = this.state.currentProtocol
            let { currentAoo, location } = this.props

            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);
            let sendMailRequest: ISendMailRequest = {
                mail: mail,
                idProtocollo: protocol.id!,
                annoProtocollo: protocol.annoProtocollo!,
                numeroProtocollo: protocol.numeroProtocollo!
            }
            pecmailService.sendMail(currentAoo.id, uorId, mail.from, sendMailRequest)
                .then(result => {
                    let { forceSpedizioniRefresh } = this.state
                    this.setState({ showActionsLoader: false, forceSpedizioniRefresh: !forceSpedizioniRefresh })
                    toastRef.current?.show({ severity: 'info', summary: "Spedizione", detail: `Operazione completata`, life: 5000 });
                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: "Attenzione", detail: `Spedizione non riuscita`, life: 5000 });
                    }
                    else {
                        throw error;
                    }
                });
        }
    }
    // Click sul button della commandbar
    remoteSignHandler = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ remoteSignPanelIsOpen: true });

    }

    // Click su salva del panel laterale
    remoteSignLateralPanelSubmit = (remoteSignRequest: Partial<IArubaRemoteSignRequest>) => {
        this.setState({ remoteSignPanelIsOpen: false, showActionsLoader: true })
        if (this.props.currentAoo && this.state.currentProtocol) {
            // protocol è il currentProtocol senza allegati
            let { attachments, ...protocol } = this.state.currentProtocol
            remoteSignRequest.protocol = protocol;
            let { currentAoo, location } = this.props

            const parsedQueryString = queryString.parse(location.search);
            let uorId: number = Number(parsedQueryString.uorId);

            protocolsService.signDocumentPades(currentAoo.id, uorId, this.state.currentProtocol.id!, remoteSignRequest)
                .then(result => {
                    this.setState({ showActionsLoader: false });
                    this.getProtocolBase64String(currentAoo, uorId, this.state.currentProtocol!);
                })
                .catch(error => {
                    this.setState({ showActionsLoader: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: "Attenzione", detail: `Firma del documento non riuscita`, life: 5000 });
                    }
                });
        }
    }
    dismissRemoteSignLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ remoteSignPanelIsOpen: false })
    }

    // Click sul button della commandbar per protocolReference
    addProtocolReferencesHandler = (ev: any, item: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ addProtocolReferencesPanelIsOpen: true });

    }

    // Click su salva del panel laterale
    addProtocolReferencesLateralPanelSubmit = () => {
        this.setState({ addProtocolReferencesPanelIsOpen: false });
        let { forceProtocolReferencesRefresh } = this.state
        this.setState({ forceProtocolReferencesRefresh: !forceProtocolReferencesRefresh });

    }

    dismissaAddProtocolReferencesLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ addProtocolReferencesPanelIsOpen: false })
    }

    onSelectProtocolReferce = (item: IProtocolReference) => {
        this.setState({ selectedProtocolReference: item }, this.updateCommandBarItems);
    }

    // Click sul button della command bar per aggiunta fascicolo
    addToFascicoloHandler = (ev: any, item: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({ addToFascicoloPanelIsOpen: true });
    }

    // Click su salva del panel laterale
    addToFascicoloLateralPanelSubmit = () => {
        this.setState({ addToFascicoloPanelIsOpen: false });
        let { forceFascicoliRefresh } = this.state
        this.setState({ forceFascicoliRefresh: !forceFascicoliRefresh });

    }

    dismissaAddToFascicoloLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ addToFascicoloPanelIsOpen: false })
    }

    //onSelectFascicolo = (item: IProtocolReference) => {
    //    this.setState({ selectedProtocolReference: item }, this.updateCommandBarItems);
    //}

    //dismiss
    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }

    dismissSelectUorDialog = () => {
        this.props.history.push({ pathname: `/${this.props.currentAoo!.id}` });
        this.props.updateSession({ currentUor: undefined });

        this.setState({ selectUorDialogIsOpen: false })
    }
    onSelectUorConfirmDialogSubmit = () => {
        let { url } = this.props.match;
        let uorId = this.choiceGroupRef.current?.checkedOption!['uorId'];
        const parsedQueryString = queryString.parse(this.props.location.search);
        parsedQueryString.uorId = uorId;
        const newQueryString = queryString.stringify(parsedQueryString);


        this.props.history.replace({ pathname: url, search: newQueryString });
        this.setState({ selectUorDialogIsOpen: false });

    }
    downloadDocumentHandler = (ev: any, item: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (this.state.documentPivotBarSelectedKey === 'documento') {
            let fileBase64string = this.state.currentProtocol?.documentFile?.docBase64String;
            let fileName = this.state.currentProtocol?.documentFile?.fileName;
            if (fileBase64string && fileName) {
                Utilities.SaveFileFromBase64(fileBase64string, fileName);
            }
        }
        else if (this.state.documentPivotBarSelectedKey === 'allegato') {
            let fileBase64string = this.state.allegatoBase64String;
            let fileName = this.state.allegatoName
            if (fileBase64string && fileName) {
                Utilities.SaveFileFromBase64(fileBase64string, fileName);
            }

        }
    }

    onDownloadAllButtonClick = () => {
        if (this.props.currentAoo) {
            let { currentAoo, location } = this.props;
            const parsedQueryString = queryString.parse(location.search);
            let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
            let protocolId = this.props.match.params['id'];

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name]?.cancel(protocolsService.getProtocolFilesAsZip.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name] = axios.CancelToken.source();

            toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Avviato il download degli allegati`, life: 5000 });

            protocolsService
                .getProtocolFilesAsZip(currentAoo.id, uorId, protocolId, this.cancelTokenSources[protocolsService.getProtocolFilesAsZip.name].token)
                .then(zipFile => {
                    toastRef.current?.show({ severity: 'info', summary: 'Informazione', detail: `Download degli allegati completato con successo`, life: 5000 });

                    let fileBase64string = zipFile.docBase64String;
                    let fileName = zipFile.fileName;
                    if (fileBase64string && fileName) {
                        Utilities.SaveFileFromBase64(fileBase64string, fileName);
                    }


                })
                .catch(error => {

                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else if (!error.isErrorShown) {
                        toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile completare il download degli allegati`, life: 5000 });

                    } else {
                        throw error;
                    }

                });
        };
    }

    onSelectePrinter = (printerName: string) => {
        this.setState({
            selectedPrinterName: printerName
        });
    }

    reprintLabelHandler = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        this.setState({
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: "Vuoi stampare l'etichetta del protocollo?",
                children: <PrintLabel onSelectePrinter={this.onSelectePrinter} />

            },
            confirmDialogSubmitFunction: async (ev: any) => { this.reprintLabelConfirmDialogSubmit() }
        })

    }
    reprintLabelConfirmDialogSubmit = async () => {

        let { currentAoo, currentUor } = this.props;
        let { currentProtocol, selectedPrinterName } = this.state;

        if (currentAoo && currentUor && currentUor.id && currentProtocol && currentProtocol.id && selectedPrinterName) {
            protocolsService.getSignatureForProtocol(currentAoo.id, currentUor.id, currentProtocol.id)
                .then(signature => {
                    peripheralService.print(selectedPrinterName!, signature)
                        .catch(error => {
                            if (!error.isErrorShown) {
                                toastRef.current?.show({
                                    severity: 'error',
                                    summary: "Attenzione",
                                    detail: "Non \u00e8 stato possibile stampare l'etichetta",
                                    life: 5000
                                });
                            }
                        });


                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: "Non \u00e8 stato possibile stampare l'etichetta",
                            life: 5000
                        });
                    }
                });

        }
        else {
            toastRef.current?.show({
                severity: 'error',
                summary: "Attenzione",
                detail: "Non \u00e8 stato possibile stampare l'etichetta",
                life: 5000
            });
        }

        this.setState({ confirmDialogIsOpen: false })
    }
    navigate = (path: string) => {
        let { documentPivotBarSelectedKey, detailsPivotBarSelectedKey, titolarioTouched, protocolFormMode, indiciTouched } = this.state;

        if ((documentPivotBarSelectedKey === "titolario" || detailsPivotBarSelectedKey === "titolario") && titolarioTouched) {
            this.setConfirmDialogTitolarioNonSalvatoBeforeChangePivot(() => {
                this.salvaTitolarioConfirmDialogSubmit();
                this.setState({ confirmDialogIsOpen: false });
                this.props.history.push({ pathname: path, search: this.props.location.search });
            });
        }
        else if ((documentPivotBarSelectedKey === "indici" || detailsPivotBarSelectedKey === "indici") && protocolFormMode === Indici_FormMode.Edit && indiciTouched) {
            this.setConfirmDialogIndiciNonSalvatiBeforeChangePivot(() => {
                this.salvaIndiciSubmit();
                this.setState({ confirmDialogIsOpen: false });
                this.props.history.push({ pathname: path, search: this.props.location.search });
            });
        }
        else {

            this.props.history.push({ pathname: path, search: this.props.location.search });

        }
    }

    checkProtocolValidity = (targetState, selectedFilingPlanKey, checkIndici, checkTitolario): boolean => {
        let isValid = true;

        let errors = {};
        let protocol: IProtocol = {
            ... this.state.currentProtocol
        }

        if (protocol && !protocol.documentFile) {
            isValid = false;
            errors["document"] = "selezionare un documento";
        }

        if (protocol && protocol.fields && targetState === Protocol_State.Protocollato) {

            const updatedProtocolFields: IField[] = [...protocol.fields];

            if (checkTitolario) {
                let titolarioValidity = AppUtilities.checkTitolarioFieldValidity(this.state.titolarioRequired, selectedFilingPlanKey)

                if (!titolarioValidity) {
                    isValid = false;
                    errors["filingPlan"] = "selezionare una voce di Titolario";
                }
                this.setState({
                    titolarioTouched: true,
                    titolarioValid: titolarioValidity
                });

            }

            protocol.fields.forEach((item) => {

                let fieldTouched = false;
                let fieldValidity = true;
                if (checkIndici && !item.system && !item.readonly && item.internalName !== 'Title' && item.internalName !== 'Titolario') {
                    fieldTouched = true;
                    fieldValidity = AppUtilities.checkFieldValidity(item)
                    if (!fieldValidity) {
                        isValid = false;
                        errors["indexes"] = "compilare correttamente gli Indici";
                    }
                }



                let fieldIndex = updatedProtocolFields.findIndex(el => el.internalName == item.internalName);
                if (fieldIndex >= 0) {
                    updatedProtocolFields[fieldIndex] = {
                        ...item,
                        touched: fieldTouched,
                        valid: fieldValidity
                    };
                }

            })
            protocol.fields = updatedProtocolFields;

        }


        let errorMessage = AppUtilities.getMessageFromErrorObjectValidity(errors);
        this.setState({
            currentProtocol: protocol,
            showMessageBar: !isValid,
            messageBarType: MessageBarType.error,
            messageBarText: errorMessage
        })
        return isValid;
    }


    indiciInputChangedHandler = (newField: IField) => {

        const protocolForm: IProtocol = {
            ...this.state.currentProtocol
        }
        if (protocolForm.fields) {
            const updatedProtocolFormFields = [...(protocolForm.fields) ?? []];
            let itemIndex = updatedProtocolFormFields.findIndex(el => el.internalName === newField.internalName);
            updatedProtocolFormFields[itemIndex] = { ...newField };

            protocolForm.fields = [...updatedProtocolFormFields];

            this.setState({
                currentProtocol: protocolForm,
                indiciTouched: true
            });
        }

    }


    onDocumentPivotBarItemClick = (selectedItemKey: string) => {
        let { documentPivotBarSelectedKey, titolarioTouched, protocolFormMode, indiciTouched } = this.state;
        let _pivotItems = this.remapCommandBarItemsAsPivotItems(this.state.documentPivotBarItems, selectedItemKey, this.onDocumentPivotBarItemClick);

        if (documentPivotBarSelectedKey === "titolario" && titolarioTouched) {
            this.setConfirmDialogTitolarioNonSalvatoBeforeChangePivot(() => {
                this.salvaTitolarioConfirmDialogSubmit();
                this.setState({
                    confirmDialogIsOpen: false,
                    documentPivotBarSelectedKey: selectedItemKey,
                    documentPivotBarItems: _pivotItems
                }, this.updateCommandBarItems);

            });
        }
        else if (documentPivotBarSelectedKey === "indici" && protocolFormMode === Indici_FormMode.Edit && indiciTouched) {
            this.setConfirmDialogIndiciNonSalvatiBeforeChangePivot(() => {
                this.salvaIndiciSubmit();
                this.setState({
                    confirmDialogIsOpen: false,
                    documentPivotBarSelectedKey: selectedItemKey,
                    documentPivotBarItems: _pivotItems
                }, this.updateCommandBarItems);

            });
        }
        else {

            this.setState({ documentPivotBarSelectedKey: selectedItemKey, documentPivotBarItems: _pivotItems }, this.updateCommandBarItems);

        }
    }

    onDetailsPivotBarItemClick = (selectedItemKey: string) => {
        let _pivotItems = this.remapCommandBarItemsAsPivotItems(this.state.detailsPivotBarItems, selectedItemKey, this.onDetailsPivotBarItemClick);
        let { detailsPivotBarSelectedKey, titolarioTouched, protocolFormMode, indiciTouched } = this.state;
        if (detailsPivotBarSelectedKey === "titolario" && titolarioTouched) {
            this.setConfirmDialogTitolarioNonSalvatoBeforeChangePivot(() => {
                this.salvaTitolarioConfirmDialogSubmit();
                this.setState({
                    confirmDialogIsOpen: false,
                    detailsPivotBarSelectedKey: selectedItemKey,
                    detailsPivotBarItems: _pivotItems
                }, this.updateCommandBarItems);

            });
        }
        else if (detailsPivotBarSelectedKey === "indici" && protocolFormMode === Indici_FormMode.Edit && indiciTouched) {
            this.setConfirmDialogIndiciNonSalvatiBeforeChangePivot(() => {
                this.salvaIndiciSubmit();
                this.setState({
                    confirmDialogIsOpen: false,
                    detailsPivotBarSelectedKey: selectedItemKey,
                    detailsPivotBarItems: _pivotItems
                }, this.updateCommandBarItems);

            });
        }
        else {
            this.setState({ detailsPivotBarSelectedKey: selectedItemKey, detailsPivotBarItems: _pivotItems }, this.updateCommandBarItems);
        }
    }
    setConfirmDialogTitolarioNonSalvatoBeforeChangePivot = (onConfirmFunction: Function) => {
        if (this.state.currentProtocol) {
            let { currentProtocol } = this.state
            if (this.checkProtocolValidity(currentProtocol.statoProtocollo, this.state.selectedFilingPlanKey, false, true)) {

                this.setState({
                    confirmDialogIsOpen: true,
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: "Salvare il Titolario prima di procedere?",
                    },
                    confirmDialogSubmitFunction: () => {
                        onConfirmFunction();
                    }
                });
            }
        }
    }
    setConfirmDialogIndiciNonSalvatiBeforeChangePivot = (onConfirmFunction: Function) => {
        if (this.state.currentProtocol) {
            let { statoProtocollo, titolario } = this.state.currentProtocol;

            if (this.checkProtocolValidity(statoProtocollo, titolario, true, false)) {

                this.setState({
                    confirmDialogIsOpen: true,
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: "Salvare gli Indici prima di procedere?",
                    },
                    confirmDialogSubmitFunction: () => {
                        onConfirmFunction();
                    }
                });
            }
        }
    }

    onInputFileChange = async (files) => {

        const parsedQueryString = queryString.parse(this.props.location.search);
        if (this.props.currentAoo && parsedQueryString.uorId && this.state.currentProtocol) {

            let _currentAoo = this.props.currentAoo
            let _currentProtocol = { ...this.state.currentProtocol };
            let { attachments } = _currentProtocol;
            let filesList = [...files]

            let uorId: number = Number(parsedQueryString.uorId);

            for (let file of filesList) {
                let docFile = await this.myFileReader(file);

                if (_currentProtocol && _currentProtocol.id) {
                    if (attachments && attachments?.findIndex(el => el.fileName === docFile.fileName) < 0) {
                        attachments?.push(docFile);
                        _currentProtocol.attachments = attachments?.slice();
                        this.setState({ currentProtocol: _currentProtocol }, this.updateDocumentAndDetailsPivotBarItems);
                        protocolsService.addAttachment(_currentAoo.id, uorId, _currentProtocol.id, docFile)
                            .then(() => {
                                toastRef.current?.show({ severity: 'info', summary: docFile.fileName, detail: `Caricato correttamente`, life: 5000 });
                                this.getProtocol(_currentAoo, uorId);
                            })
                            .catch(error => {
                                if (!error.isErrorShown) {
                                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `${docFile.fileName} non caricato`, life: 5000 });
                                }
                            });


                    }
                }
            }


            if (this.uploadInputRef && this.uploadInputRef.current) {
                this.uploadInputRef.current.value = '';
            }
        }
    }
    onUploadButtonClick = () => {
        if (this.uploadInputRef && this.uploadInputRef.current) {
            this.uploadInputRef.current.click();
        }
    };



    myFileReader = async (file: File) => {
        return new Promise<IFile>((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                if (reader.result) {
                    const docFile: IFile = {
                        fileName: file.name,
                        fileType: "Documento",
                        extension: Utilities.GetFileExtension(file.name),
                        loading: true,
                        docBase64String: reader.result.toString().split(';base64,').pop(),
                        dimension: file.size,
                        dimensionUnit: "B"
                    }
                    resolve(docFile);
                }
            };
            reader.onerror = function (error) {
            };

        });
    }

    onAttachmentClick = (attachment: IFile) => {
        //let fileNameMaxLength = 40;
        let textFileName = attachment.originalName ? attachment.originalName : attachment.fileName;
        //if (textFileName.length > fileNameMaxLength) {
        //    textFileName = textFileName.substring(0, fileNameMaxLength) + '...';
        //}
        let allegato: ICommandBarItemProps = {
            key: 'allegato',
            text: textFileName,

        };
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;


        let _pivotItems = [...this.state.documentPivotBarItems];


        if (_pivotItems.findIndex(it => it.key === 'allegato') < 0)
            _pivotItems.splice(1, 0, allegato);
        else
            _pivotItems.splice(1, 1, allegato);

        _pivotItems = this.remapCommandBarItemsAsPivotItems(_pivotItems, 'allegato', this.onDocumentPivotBarItemClick);

        if (attachment.docBase64String) {
            this.setState({
                documentPivotBarItems: _pivotItems,
                allegatoBase64String: attachment.docBase64String,
                allegatoName: attachment.originalName ? attachment.originalName : attachment.fileName,
                documentPivotBarSelectedKey: 'allegato'
            }, this.updateCommandBarItems)
        }
        else {
            if (this.props.currentAoo && this.state.currentProtocol) {
                protocolsService.getFileSPById(this.props.currentAoo.id, uorId, this.props.match.params['id'], attachment.id!)
                    .then(fileResult => {
                        this.setState({
                            documentPivotBarItems: _pivotItems,
                            allegatoBase64String: fileResult.docBase64String,
                            allegatoName: attachment.originalName ? attachment.originalName : attachment.fileName,
                            documentPivotBarSelectedKey: 'allegato'
                        }, this.updateCommandBarItems)
                    })
            }
        }
    }

    onRemoveAttchmentClick = (ev, attachment: IFile) => {
        ev.stopPropagation();
        ev.preventDefault();
        const parsedQueryString = queryString.parse(this.props.location.search);

        if (this.props.currentAoo && parsedQueryString.uorId && this.state.currentProtocol) {

            let _currentAoo = this.props.currentAoo
            let _currentProtocol = { ...this.state.currentProtocol };
            let { attachments } = _currentProtocol;
            if (attachments) {
                let attachIndex = attachments.findIndex(el => el.fileName === attachment.fileName);
                let attach = { ...attachments[attachIndex] }
                attach.loading = true;

                attachments[attachIndex] = { ...attach };
                _currentProtocol.attachments = attachments;
                this.setState({ currentProtocol: _currentProtocol }, this.updateDocumentAndDetailsPivotBarItems);

                let uorId: number = Number(parsedQueryString.uorId);

                if (_currentProtocol && _currentProtocol.id && attachment.id) {
                    protocolsService.deleteAttachment(_currentAoo.id, uorId, _currentProtocol.id, attachment.id)
                        .then(() => {
                            toastRef.current?.show({ severity: 'info', summary: attachment.fileName, detail: `Eliminato correttamente`, life: 5000 });

                            this.getProtocol(_currentAoo, uorId);

                        },
                            error => {
                                if (!error.isErrorShown) {
                                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `${attachment.fileName} non eliminato`, life: 5000 });
                                }
                                let _currentProtocol = { ...this.state.currentProtocol };
                                let { attachments } = _currentProtocol;
                                if (attachments) {
                                    let attachIndex = attachments.findIndex(el => el.fileName === attachment.fileName);
                                    let attach = { ...attachments[attachIndex] }
                                    attach.loading = false;

                                    attachments[attachIndex] = { ...attach };
                                    _currentProtocol.attachments = attachments;
                                    this.setState({ currentProtocol: _currentProtocol }, this.updateDocumentAndDetailsPivotBarItems);
                                }
                            });

                }
            }
        }
    }

    onDeleteReference = (message: ToastMessageType) => {
        let { forceProtocolReferencesRefresh } = this.state
        this.setState({ forceProtocolReferencesRefresh: !forceProtocolReferencesRefresh });
        toastRef.current?.show(message);
    }

    onDeleteFascicolo = (message: ToastMessageType) => {
        let { forceFascicoliRefresh } = this.state
        this.setState({ forceFascicoliRefresh: !forceFascicoliRefresh });
        toastRef.current?.show(message);
    }

    remapCommandBarItemsAsPivotItems = (items: ICommandBarItemProps[], selectedItemKey: string, onClickFunction: Function) => {
        const { currentProtocol } = this.state;

        return items.map(it => {
            let _className = classes.commandbarAsPivot;
            if (it.key === selectedItemKey)
                _className += ` ${classes.isSelected}`;
            let badge: any = undefined;

            if (it.key === 'allegati' && currentProtocol && currentProtocol.attachments && currentProtocol.attachments.length > 0) {
                if (currentProtocol.attachments.length <= 10)
                    badge = currentProtocol.attachments.length;
                else
                    badge = '10+';

            }
            return (
                {
                    ...it,
                    onClick: () => { onClickFunction(it.key); },
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton text={it.text}
                            key={it.key}
                            badge={badge}
                            className={_className}
                            onClick={() => { onClickFunction(it.key); }} />
                    )
                }
            );
        });
    }


    updateIndiciFormMode = (currentProtocol: IProtocol) => {
        let indiciMode: Indici_FormMode = Indici_FormMode.ReadOnly;
        if (abilityBuild.cannot('update', subject('IProtocol', currentProtocol))) {
            indiciMode = Indici_FormMode.ReadOnly;
        }
        else if (currentProtocol.statoProtocollo === Protocol_State.Protocollato || currentProtocol.statoProtocollo === Protocol_State.Annullato) {
            indiciMode = Indici_FormMode.ReadOnly;
        }
        else
            indiciMode = Indici_FormMode.Edit;
        this.setState({ protocolFormMode: indiciMode })


    }

    updateCommandBarItems = () => {
        const { currentProtocol, currentProtocolloAreaDiLavoro } = this.state;
        const { currentAoo, currentUor, currentUser } = this.props
        if (currentProtocol) {
            let newCommandBarItems: ICommandBarItemProps[] = [];

            if (abilityBuild.can('update', subject('IProtocol', currentProtocol))
                && (currentProtocol.statoProtocollo === Protocol_State.InCreazione || currentProtocol.statoProtocollo === Protocol_State.Acquisito || currentProtocol.statoProtocollo === Protocol_State.Allocato)) {
                newCommandBarItems.push({
                    key: 'protocolla',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Protocolla'
                            key='protocolla'
                            iconPropsFontAwesome={{ icon: ['fal', 'file-certificate'] }}
                            onClick={this.protocollaDocumentoHandler}
                        />
                    )
                });
            }

            let undoRequest = this.state.currentProtocolUndoRequests.find(r => r.protocolEFId === this.state.currentProtocolEF?.id);

            if (abilityBuild.can('update', subject('IProtocol', currentProtocol)) && (currentProtocol.statoProtocollo === Protocol_State.Acquisito || currentProtocol.statoProtocollo === Protocol_State.Protocollato))
                newCommandBarItems = [{
                    key: 'undoProtocol',


                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Annulla protocollo'
                            key='undoProtocol'
                            iconPropsIcoMoon={{ className: 'icomoon-file-certificate-slash-light' }}
                            onClick={this.annullaProtocolloHandler}
                            disabled={undoRequest && undoRequest.stato === RichiestaAnnullamento_Status.InCorso ? true : false}
                        />
                    )

                }, ...newCommandBarItems];

            /// i protocolli che hanno id e numero id protocollo hanno anche un'etichetta
            if (currentProtocol.id && currentProtocol.numeroProtocollo
                && abilityBuild.can('update', subject('IProtocol', currentProtocol))
                && abilityBuild.can('use', subject('IFeature', { key: 'StampaEtichetta', enabled: true }))) {
                newCommandBarItems.push(...[
                    {
                        key: 'reprintLabel',
                        commandBarButtonAs: () => (
                            <CustomCommandBarButton
                                text='Stampa etichetta'
                                key='reprintLabel'
                                iconProps={{ iconName: 'QRCode' }}
                                onClick={this.reprintLabelHandler}
                            />
                        )
                    }
                ]);
            }

            // ricavo le uor in cui l'utente corrente ha ruolo Operatore
            const userOperatoreUor = currentUser?.ruoliUorContext.reduce((a: IUor[], o) => (o.uor && o.uor.aooId === currentAoo?.id && o.ruolo && o.ruolo.nome === "Operatore" && a.push(o.uor), a), []) ?? [];

            // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
            // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
            // creare il protocollo

            if (userOperatoreUor.length > 0) {
                newCommandBarItems.push({
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: this.createProtocolFromHandler
                });
            }

            if (abilityBuild.can('update', subject('IProtocol', currentProtocol)) && currentProtocol.statoProtocollo !== Protocol_State.Protocollato && currentProtocol.statoProtocollo !== Protocol_State.Annullato) {
                newCommandBarItems.push({
                    key: 'reloadProtocol',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Ricarica protocollo'
                            key='reloadProtocol'
                            iconPropsIcoMoon={{ className: 'icomoon-file-redo-light' }}
                            onClick={this.reloadProtocolHandler}
                        />
                    )
                });
            }

            if (currentProtocol.statoProtocollo === Protocol_State.Protocollato
                && abilityBuild.can('read', subject('IProtocol', currentProtocol)) && abilityBuild.can('use', subject('IFeature', { key: 'AreaDiLavoro', enabled: true }))) {

                if (abilityBuild.can('create', 'IProtocolloAreaDiLavoro') && (!currentProtocolloAreaDiLavoro || (currentProtocolloAreaDiLavoro && currentProtocolloAreaDiLavoro.statoLavorazione === ProtocolloAreaDiLavoroEF_State.Lavorato))) {
                    newCommandBarItems.push({
                        key: 'addAreaLavoro',
                        commandBarButtonAs: () => (
                            <CustomCommandBarButton
                                text="Aggiungi all'area di lavoro"
                                key='addAreaLavoro'
                                iconPropsFontAwesome={{ icon: ['fal', 'person-digging'] }}
                                onClick={this.addAreaLavoroHandler}
                            />
                        )
                    });
                }
                if (abilityBuild.can('update', 'IProtocolloAreaDiLavoro') && currentProtocolloAreaDiLavoro && currentProtocolloAreaDiLavoro.statoLavorazione === ProtocolloAreaDiLavoroEF_State.DaLeggere) {
                    newCommandBarItems.push({
                        key: 'avviaLavorazione',
                        text: 'Avvia lavorazione',
                        iconProps: { iconName: 'Play' },
                        onClick: this.onAvviaLavorzioneClick
                    });
                }
                if (abilityBuild.can('update', 'IProtocolloAreaDiLavoro') && currentProtocolloAreaDiLavoro && currentProtocolloAreaDiLavoro.statoLavorazione === ProtocolloAreaDiLavoroEF_State.InLavorazione) {
                    newCommandBarItems.push({
                        key: 'terminaLavorzione',
                        text: 'Termina lavorazione',
                        iconProps: { iconName: 'CheckList' },
                        onClick: this.onTerminaLavorzioneClick
                    });
                }
            }
            if ((this.state.documentPivotBarSelectedKey === 'documento' || this.state.documentPivotBarSelectedKey === 'allegato')) {

                if (currentProtocol.hasAttachments) {
                    newCommandBarItems.push({
                        key: 'downloadDocument',
                        text: 'Scarica',
                        iconProps: { iconName: 'DownloadDocument' },
                        split: true,
                        onClick: this.downloadDocumentHandler,
                        subMenuProps: {
                            items: [
                                {
                                    key: 'downloadAll',
                                    text: 'Scarica tutto',
                                    iconProps: { iconName: 'Download' },
                                    onClick: this.onDownloadAllButtonClick
                                },
                            ],
                        }

                    });

                }
                else {
                    newCommandBarItems.push({
                        key: 'downloadDocument',
                        text: 'Scarica',
                        iconProps: { iconName: 'DownloadDocument' },
                        onClick: this.downloadDocumentHandler
                    });
                }

            }

            if (currentProtocol.statoProtocollo === Protocol_State.Protocollato && currentProtocol.tipoProtocollo === Protocol_Type.DocumentoInUscita
                && currentUor && currentUor.mailboxesOut && currentUor.mailboxesOut.length > 0
                && abilityBuild.can('use', subject('IFeature', { key: 'PecMail', enabled: true }))
                && abilityBuild.can('update', subject('IProtocol', currentProtocol))) {
                newCommandBarItems.push({
                    key: 'spedisci',
                    text: 'Spedisci',
                    iconProps: { iconName: 'Send' },
                    onClick: this.sendMailHandler
                });
            }
            if ((currentProtocol.statoProtocollo === Protocol_State.Protocollato || currentProtocol.statoProtocollo === Protocol_State.Acquisito)
                && abilityBuild.can('use', subject('IFeature', { key: 'ArubaRemoteSign', enabled: true }))
                && abilityBuild.can('sign', subject('IProtocol', currentProtocol))
                && this.state.documentPivotBarSelectedKey === 'documento') {
                newCommandBarItems.push({
                    key: 'firma',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            text='Firma documento'
                            key='firma'
                            iconPropsFontAwesome={{ icon: ['fal', 'signature'] }}
                            onClick={this.remoteSignHandler}
                        />
                    )
                });
            }

            if (abilityBuild.can('use', subject('IFeature', { key: 'Teams', enabled: true })) && currentProtocol.statoProtocollo === Protocol_State.Protocollato) {
                newCommandBarItems.push(
                    {
                        key: 'teams',
                        text: 'Teams',
                        iconProps: { iconName: 'TeamsLogo' },
                        onClick: this.creaCanaleTeamsHandler
                    });
            }

            if (abilityBuild.can('use', subject('IFeature', { key: 'Archive', enabled: true })) && currentProtocol.statoProtocollo === Protocol_State.Protocollato) {
                newCommandBarItems.push(
                    {
                        key: 'archivia',
                        text: 'Archivia',
                        iconProps: { iconName: 'OfflineStorage' },
                        onClick: this.archiviaProtocolloHandler
                    }
                );
            }


            if (this.state.detailsPivotBarSelectedKey === 'allegati' || this.state.documentPivotBarSelectedKey === 'allegati') {

                let canUpdateProtocolAttachments = currentProtocol.statoProtocollo !== Protocol_State.Annullato
                    && (currentProtocol.statoProtocollo !== Protocol_State.Protocollato
                        || (currentProtocol.statoProtocollo === Protocol_State.Protocollato && abilityBuild.can('use', subject('IFeature', { key: 'ModificaAllegatiPostProtocollazione', enabled: true }))));

                if (canUpdateProtocolAttachments && abilityBuild.can('update', subject('IProtocol', currentProtocol))) {
                    newCommandBarItems.push({
                        key: 'addAttachment',
                        text: 'Aggiungi allegato',
                        iconProps: { iconName: 'Attach' },
                        onClick: this.onUploadButtonClick
                    });
                }


            }
            if (currentProtocol.statoProtocollo === Protocol_State.Protocollato
                && (this.state.detailsPivotBarSelectedKey === 'indici' || this.state.documentPivotBarSelectedKey === 'indici')
                && this.state.protocolFormMode != Indici_FormMode.Edit
                && abilityBuild.can('update', subject('IProtocol', currentProtocol))) {
                newCommandBarItems.push({
                    key: 'editIndexes',
                    text: 'Modifica indici',
                    iconProps: { iconName: 'Edit' },
                    onClick: this.editIndexesProtocolHandler
                });

            }


            if (abilityBuild.can('update', subject('IProtocol', currentProtocol))
                && (this.state.detailsPivotBarSelectedKey === 'indici' || this.state.documentPivotBarSelectedKey === 'indici')
                && this.state.protocolFormMode === Indici_FormMode.Edit)
                newCommandBarItems.push({
                    key: 'salvaIndici',
                    text: 'Salva indici',
                    iconProps: { iconName: 'CheckMark' },
                    onClick: this.salvaIndiciHandler
                });

            if (currentProtocol.statoProtocollo === Protocol_State.Protocollato
                && (this.state.detailsPivotBarSelectedKey === 'indici' || this.state.documentPivotBarSelectedKey === 'indici')
                && this.state.protocolFormMode === Indici_FormMode.Edit
                && abilityBuild.can('update', subject('IProtocol', currentProtocol))) {
                newCommandBarItems.push({
                    key: 'undoEdit',
                    text: 'Annulla modifiche',
                    iconProps: { iconName: 'Cancel' },
                    onClick: this.undoEditIndexesProtocolHandler
                });

            }

            if (abilityBuild.can('update', subject('IProtocol', currentProtocol)) && (this.state.detailsPivotBarSelectedKey === 'visibilita' || this.state.documentPivotBarSelectedKey === 'visibilita'))
                newCommandBarItems.push({
                    key: 'salvaVisibilita',
                    text: 'Salva Visibilità',
                    iconProps: { iconName: 'CheckMark' },
                    onClick: this.salvaVisibilitaHandler
                });

            if (abilityBuild.can('update', subject('IProtocol', currentProtocol)) && (this.state.detailsPivotBarSelectedKey === 'titolario' || this.state.documentPivotBarSelectedKey === 'titolario'))
                newCommandBarItems.push({
                    key: 'salvaTitolario',
                    text: 'Salva Titolario',
                    iconProps: { iconName: 'CheckMark' },
                    onClick: this.salvaTitolarioHandler
                });

            if (currentProtocol.statoProtocollo === Protocol_State.Protocollato
                && (this.state.detailsPivotBarSelectedKey === 'protocolReferences' || this.state.documentPivotBarSelectedKey === 'protocolReferences')
                && abilityBuild.can('update', subject('IProtocol', currentProtocol))) {
                newCommandBarItems.push({
                    key: 'addProtocolReferences',
                    text: 'Aggiungi riferimento',
                    iconProps: { iconName: 'DocumentReply' },
                    onClick: this.addProtocolReferencesHandler
                });
            }

            if (currentProtocol.statoProtocollo === Protocol_State.Protocollato
                && (this.state.detailsPivotBarSelectedKey === 'fascicolo' || this.state.documentPivotBarSelectedKey === 'fascicolo')
                && abilityBuild.can('update', subject('IProtocol', currentProtocol))) {
                newCommandBarItems.push({
                    key: 'addToFascicolo',
                    text: 'Aggiungi al fascicolo',
                    iconProps: { iconName: 'DocumentReply' },
                    onClick: this.addToFascicoloHandler
                });
            }

            if (abilityBuild.can('use', subject('IFeature', { key: 'Esibizione', enabled: true })) && abilityBuild.can('read', subject('IProtocol', currentProtocol))) {
                let esibizioneMenu: IContextualMenuItem[] = [];
                let esibizioneAppUrl = this.props.arxeiaConfigurations?.find(el => el.key === "EsibizioneAppUrl")

                if (currentProtocol.documentFile?.idDocConservazione && esibizioneAppUrl && esibizioneAppUrl.value) {
                    let esibizioneAppUrlValue = esibizioneAppUrl.value;
                    let documentFile = currentProtocol.documentFile;
                    esibizioneMenu.push({
                        key: documentFile.fileName,
                        text: documentFile.fileName,
                        onClick: () => {
                            exhibitionsService.insertExhibitionAuditOperation(currentAoo!.id, currentProtocol.id!, documentFile.fileName, currentUor?.id).then();
                            Utilities.OpenUrlInNewTab(`${esibizioneAppUrlValue}/#/esibizione?idpdv=${currentProtocol.idPdVConservazione}&iddoc=${documentFile!.idDocConservazione}`)
                        }
                    });
                    currentProtocol.attachments?.forEach(el => {
                        if (el.idDocConservazione) {
                            esibizioneMenu.push({
                                key: el.fileName,
                                text: el.fileName,
                                onClick: () => {
                                    exhibitionsService.insertExhibitionAuditOperation(currentAoo!.id, currentProtocol.id!, el.fileName, currentUor?.id).then();
                                    Utilities.OpenUrlInNewTab(`${esibizioneAppUrlValue}/#/esibizione?idpdv=${currentProtocol.idPdVConservazione}&iddoc=${el.idDocConservazione}`)
                                }
                            });
                        }
                    });
                }

                if (esibizioneMenu.length > 0) {
                    newCommandBarItems.push({
                        key: 'esibizione',
                        commandBarButtonAs: () => (
                            <CustomCommandBarButton
                                text='Esibizione'
                                key='esibizione'
                                split={true}
                                menuProps={
                                    { items: esibizioneMenu }
                                }
                                iconPropsFontAwesome={{ icon: ['fal', 'cabinet-filing'] }}
                            />
                        )
                    });
                }

            }
            this.setState({ commandBarItems: newCommandBarItems })
        }
    }

    updateDocumentAndDetailsPivotBarItems = () => {
        const { currentProtocol, documentPivotBarItems } = this.state;

        let newDocumentPivotBarItems = documentPivotBarDefaultItems.slice();

        if (documentPivotBarItems && documentPivotBarItems.length > 0)
            newDocumentPivotBarItems = [...documentPivotBarItems];

        let detailsPivotBarItems: ICommandBarItemProps[] = [];
        detailsPivotBarItems.push(...[
            {
                key: 'indici',
                text: 'Indici',
            },
            {
                key: 'allegati',
                text: 'Allegati',
            },
        ]);

        detailsPivotBarItems.push(
            {
                key: 'titolario',
                text: 'Titolario',
            });
        detailsPivotBarItems.push(...[

            //{
            //    key: 'annotazioni',
            //    text: 'Annotazioni',
            //},
            {
                key: 'storia',
                text: 'Storia',
            },
        ]);
        detailsPivotBarItems.push(
            {
                key: 'versioni',
                text: 'Versioni',
            });

        if (currentProtocol && (currentProtocol.statoProtocollo === Protocol_State.Protocollato || currentProtocol.statoProtocollo === Protocol_State.Annullato)
            && abilityBuild.can('use', subject('IFeature', { key: 'Fascicoli', enabled: true }))) {

            detailsPivotBarItems.push(

                {
                    key: 'fascicolo',
                    text: 'Fascicoli',
                });

        }
        if (currentProtocol
            && (currentProtocol.statoProtocollo === Protocol_State.Protocollato || currentProtocol.statoProtocollo === Protocol_State.Annullato)) {
            detailsPivotBarItems.push(
                {
                    key: 'visibilita',
                    text: 'Visibilità',
                });
        }
        if (currentProtocol
            && (currentProtocol.statoProtocollo === Protocol_State.Protocollato)) {
            detailsPivotBarItems.push(
                {
                    key: 'protocolReferences',
                    text: 'Riferimenti',
                });
        }
        if (currentProtocol && abilityBuild.can('use', subject('IFeature', { key: 'StampaEInvia', enabled: true }))
            && abilityBuild.can('read', 'IPrintAndSend')) {
            detailsPivotBarItems.push(
                {
                    key: 'stampaeinvia',
                    text: 'Stampa e invia',
                }
            );
        }
        if (currentProtocol && currentProtocol.tipoProtocollo === Protocol_Type.DocumentoInUscita
            && abilityBuild.can('read', subject('IProtocol', currentProtocol))) {
            detailsPivotBarItems.push(
                {
                    key: 'spedizioni',
                    text: 'Spedizioni',
                });
        }
        if (this.props.isMobile) {
            let newdocumentPivotBarItems = [...newDocumentPivotBarItems, ...detailsPivotBarItems];
            let documentPivotBarItemsRemap = this.remapCommandBarItemsAsPivotItems(newdocumentPivotBarItems, this.state.documentPivotBarSelectedKey, this.onDocumentPivotBarItemClick)

            this.setState({ documentPivotBarItems: documentPivotBarItemsRemap, detailsPivotBarItems: [] });

        }
        else {
            let documentPivotBarItemsRemap = this.remapCommandBarItemsAsPivotItems(newDocumentPivotBarItems, this.state.documentPivotBarSelectedKey, this.onDocumentPivotBarItemClick)
            let detailsPivotBarItemsRemap = this.remapCommandBarItemsAsPivotItems(detailsPivotBarItems, this.state.detailsPivotBarSelectedKey, this.onDetailsPivotBarItemClick)

            this.setState({ documentPivotBarItems: documentPivotBarItemsRemap, detailsPivotBarItems: detailsPivotBarItemsRemap });

        }
    }


    getShimmerElementsGroupCommandBar = (): JSX.Element => {
        return (
            <div >

                <div style={{
                    width: '100%', height: '44px',
                    borderBottom: '1px solid rgb(238, 238, 238)'
                }}>

                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.gap, height: 43, width: 20 },
                            { type: ShimmerElementType.line, height: 15, width: 65 },
                            { type: ShimmerElementType.gap, height: 43, width: 8 },
                            { type: ShimmerElementType.line, height: 15, width: 65 },
                            { type: ShimmerElementType.gap, height: 43, width: 8 },
                            { type: ShimmerElementType.line, height: 15, width: 65 },
                            { type: ShimmerElementType.gap, height: 43, width: 8 },
                            { type: ShimmerElementType.line, height: 15, width: 65 },
                            { type: ShimmerElementType.gap, height: 43, width: '100%' },
                        ]}
                    />
                </div>
            </div>
        );
    };


    dismissSendMailPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ sendMailPanelIsOpen: false })
    }

    toggleIsCalloutVisible = () => {
        this.setState({ isCalloutVisible: !this.state.isCalloutVisible })
    }

    renderPivotContent = (pivotKey) => {
        if (this.state.currentProtocol) {
            let { currentProtocol, currentProtocolEF } = this.state;
            switch (pivotKey) {
                case 'documento':
                    return (
                        <div className={`position-relative my-scroll-div`}>
                            <PdfViewer base64String={currentProtocol.documentFile?.docBase64String} initialLoading={true} />
                        </div>
                    );
                case 'allegato':
                    return (
                        <div className={`position-relative my-scroll-div`}>
                            <PdfViewer base64String={this.state.allegatoBase64String} initialLoading={true} />
                        </div>
                    );
                case 'indici':
                    let undoRequest = this.state.currentProtocolUndoRequests.find(r => r.protocolEFId === currentProtocolEF?.id);
                    return (
                        <>
                            {abilityBuild.can('use', subject('IFeature', { key: 'RichiesteDiAnnullamento', enabled: true })) && undoRequest
                                && undoRequest.stato === RichiestaAnnullamento_Status.InCorso &&
                                <DefaultButton
                                    id={'infoRichiestaAnnullamento'}
                                    onClick={this.toggleIsCalloutVisible}
                                    text={`Richiesta di annullamento: ${RichiestaAnnullamento_Status_Label.get(undoRequest.stato)}`}
                                    className={styles.button}
                                />
                            }
                            {this.state.isCalloutVisible && undoRequest &&
                                <Callout
                                    className={styles.callout}
                                    role="dialog"
                                    gapSpace={0}
                                    target={'#infoRichiestaAnnullamento'}
                                    onDismiss={this.toggleIsCalloutVisible}
                                    setInitialFocus
                                >
                                    <Text as="h2" block variant="medium" className={styles.title}>
                                        Richiedente: {undoRequest.richiedente.displayName}
                                    </Text>
                                    <Text block variant="small">
                                        Motivazione richiesta: {undoRequest.motivazioneRichiesta}
                                    </Text>
                                </Callout>
                            }

                            <Indici
                                fields={AppUtilities.fixFieldsForm(this.state.protocolFormMode, currentProtocol.fields!)}
                                loading={this.state.showIndexesLoader}
                                onIndiciInputChangedHandler={(newField) => { this.indiciInputChangedHandler(newField) }}
                            />
                        </>
                    );
                case 'allegati':
                    return (
                        <Allegati
                            protocol={currentProtocol}
                            onAttchmentClick={(item) => this.onAttachmentClick(item)}
                            onRemoveAttchmentClick={(ev, item) => this.onRemoveAttchmentClick(ev, item)}
                        />
                    );
                case 'visibilita':
                    return (
                        <Visibilita
                            visibilita={currentProtocol.visibilita}
                            readOnlyMode={abilityBuild.cannot('update', subject('IProtocol', currentProtocol))}
                            onUpdateVisibilitaHandler={
                                (visibilita) => {
                                    this.setState({ selectedVisibilita: visibilita });
                                }
                            }
                            viewMode={Visibilita_ViewMode.ActiveOnly}
                        />
                    );
                case 'titolario':
                    return (
                        <React.Fragment>
                            <div className={`position-relative my-scroll-div`}>
                                <div className={!this.state.titolarioValid ? 'titolario field error' : 'titolario field'} >
                                    {!this.state.titolarioValid && <span className="error-message" style={{ paddingLeft: "30px" }} >Campo obbligatorio</span>}
                                    <FilingPlanTree
                                        extraCssClass={`flex flex-column position-relative`}
                                        readOnlyMode={abilityBuild.cannot('update', subject('IProtocol', currentProtocol))}
                                        selectedFilingPlanKey={this.state.selectedFilingPlanKey ? this.state.selectedFilingPlanKey : undefined}
                                        onSelectFilingPlanKeyHandler={
                                            (titolario) => {
                                                this.setState({
                                                    selectedFilingPlanKey: titolario,
                                                    titolarioTouched: true
                                                });
                                            }
                                        }
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    );
                case 'annotazioni':
                    return (
                        <Annotazioni />
                    );
                case 'storia':
                    return (
                        <Storia protocol={currentProtocol} />
                    );
                case 'versioni':
                    return (
                        <Versioni protocol={currentProtocol} />
                    );
                case 'fascicolo':
                    return (
                        <FascicoliDiProtocollo {...this.props}
                            currentProtocol={currentProtocol}
                            forceFascicoliRefresh={this.state.forceFascicoliRefresh}
                            onDeleteFascicolo={this.onDeleteFascicolo}
                        />
                    );
                case 'stampaeinvia':
                    return (
                        <SEI protocol={currentProtocol} />
                    );
                case 'protocolReferences':
                    return (
                        <ProtocolReferences {...this.props}
                            protocol={currentProtocol}
                            forceProtocolReferencesRefresh={this.state.forceProtocolReferencesRefresh}
                            onDeleteReference={this.onDeleteReference}
                        />
                    );
                case 'spedizioni':
                    return <Spedizioni
                        forceSpedizioniRefresh={this.state.forceSpedizioniRefresh}
                        protocol={currentProtocol}
                    />
            }
        }
    }


    // TEST per includere l'icona della visibilità - INCOMPLETO
    onRenderSelectUorChoiceGroupItem: IRenderFunction<IChoiceGroupOption & IChoiceGroupOptionProps> = (props, defaultRender) => {
        let tipologia = props!['tipologia'];
        switch (tipologia) {
            case Visibility_Type.CopiaConoscenza:
                return (
                    <React.Fragment>
                        <TooltipHost content="Copia conoscenza">
                            <div style={{
                                display: "inline",
                                marginRight: "7px"
                            }}>
                                {defaultRender!(props)}
                            </div>
                            <FontIcon aria-label="Copia conoscenza" iconName="Accounts" className="visibilita-icon" />



                        </TooltipHost >
                    </React.Fragment>
                );
            case Visibility_Type.Inoltro:
                return (
                    <React.Fragment>
                        <TooltipHost content="Inoltro">
                            <div style={{
                                display: "inline",
                                marginRight: "7px"
                            }}>
                                {defaultRender!(props)}
                            </div>

                            <FontIcon aria-label="Inoltro" iconName="FastForward" className="visibilita-icon" />

                        </TooltipHost >
                    </React.Fragment>
                );
            case Visibility_Type.Visibilita:
                return (
                    <React.Fragment>
                        <TooltipHost content="Visibilita">
                            <div style={{
                                display: "inline",
                                marginRight: "7px"
                            }}>
                                {defaultRender!(props)}
                            </div>
                            <FontAwesomeIcon
                                title="So nice to see you!"
                                className="visibilita-icon"
                                icon={{ prefix: 'far', iconName: 'eye' }}
                            />

                        </TooltipHost >

                    </React.Fragment>
                );
            case Visibility_Type.Proprietario:
                return (
                    <React.Fragment>
                        <TooltipHost content="Proprietario">
                            <div style={{
                                display: "inline",
                                marginRight: "7px"
                            }}>
                                {defaultRender!(props)}
                            </div>

                            <FontAwesomeIcon
                                title="So nice to see you!"
                                className="visibilita-icon"
                                icon={{ prefix: 'fas', iconName: 'user-tie' }}
                            />

                        </TooltipHost >
                    </React.Fragment>
                );

        }
        return (
            <React.Fragment>

                <TooltipHost content="Copia conoscenza" >
                    <div style={{
                        display: "inline",
                        marginRight: "7px"
                    }}>
                        {defaultRender!(props)}
                    </div>
                    <IconButton
                        iconProps={{ iconName: 'Accounts' }}
                        title="Copia conoscenza"
                        ariaLabel="Copia conoscenza"
                    />
                </TooltipHost >
            </React.Fragment>
        );
    }






    render() {


        let mailboxes = this.props.currentUor?.mailboxesOut?.reduce((a: string[], o) => (o.mailbox.address && a.push(o.mailbox.address), a), [])
        let loaderClass = this.state.showActionsLoader ? "active" : '';
        return (
            <React.Fragment>
                <div className={"loader opacity " + loaderClass}>
                    <RippleLoader text='Operazione in corso' />
                </div>
                <div className='protocol-viewer-component flex flex-column p-nogutter'>

                    <Shimmer
                        customElementsGroup={this.getShimmerElementsGroupCommandBar()}
                        isDataLoaded={this.state.commandBarItems && this.state.commandBarItems.length > 0}
                    >
                        <CommandBar
                            items={this.state.commandBarItems}
                            overflowItems={commandBarOverflowItems}
                            overflowButtonProps={overflowProps}
                            farItems={commandBarFarItems}
                            styles={commandBarStyles}
                        />
                    </Shimmer>
                    {
                        this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={this.state.messageBarType}
                            isMultiline={false}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                    }

                    <div className="component-content flex flex-column lg:flex-row p-nogutter">
                        <div className="document-wrapper col-12 md:col-8 flex flex-column p-nogutter">
                            <CommandBar
                                items={[...this.state.documentPivotBarItems]}
                                overflowButtonProps={overflowProps}
                                styles={pivotBarStyles}

                            />
                            <div className={'pivot-wrapper'}>

                                {this.renderPivotContent(this.state.documentPivotBarSelectedKey)}

                            </div>
                        </div>
                        <div className="details-wrapper hidden md:flex md:col-4 m-0 p-0 flex-column">
                            <CommandBar
                                items={this.state.detailsPivotBarItems}
                                overflowButtonProps={overflowProps}
                                styles={pivotBarStyles}
                            />
                            <div className={'pivot-wrapper'}>

                                {this.renderPivotContent(this.state.detailsPivotBarSelectedKey)}

                            </div>
                        </div>
                    </div>
                    {this.state.sendMailPanelIsOpen &&
                        <SendMailPanel
                            sendMailPanelIsOpen={this.state.sendMailPanelIsOpen}
                            onSendMail={this.sendMailLateralPanelSubmit}
                            onDismiss={this.dismissSendMailPanel}
                            mailboxes={mailboxes}
                            {...this.props}
                        />
                    }
                    {this.state.remoteSignPanelIsOpen &&
                        <RemoteSignPanel
                            remoteSignPanelIsOpen={this.state.remoteSignPanelIsOpen}
                            onRemoteSignSubmit={this.remoteSignLateralPanelSubmit}
                            onRemoteSignDismiss={this.dismissRemoteSignLateralPanel}
                            {...this.props}
                        />
                    }
                    {this.state.addProtocolReferencesPanelIsOpen &&
                        <AddProtocolReferencesPanel
                            addProtocolReferencesPanelIsOpen={this.state.addProtocolReferencesPanelIsOpen}
                            onAddProtocolReferenceSubmit={this.addProtocolReferencesLateralPanelSubmit}
                            onAddProtocolReferenceDismiss={this.dismissaAddProtocolReferencesLateralPanel}

                            {...this.props}
                        />
                    }
                    {this.state.addToFascicoloPanelIsOpen &&
                        <AddFascicoliDiProtocolloPanel
                            addToFascicoloPanelIsOpen={this.state.addToFascicoloPanelIsOpen}
                            onAddToFascicoloSubmit={this.addToFascicoloLateralPanelSubmit}
                            onAddToFascicoloDismiss={this.dismissaAddToFascicoloLateralPanel}

                            {...this.props}
                        />
                    }
                    {this.state.undoRequestPanelIsOpen &&
                        <UndoRequestPanel
                            undoRequestPanelIsOpen={this.state.undoRequestPanelIsOpen}
                            currentProtocolEF={this.state.currentProtocolEF}
                            onUndoRequestPanelSubmit={this.undoRequestPanelSubmit}
                            onUndoRequestPanelDismiss={this.undoRequestPanelSDismiss}


                            {...this.props}
                        />
                    }
                    <Dialog
                        hidden={!this.state.confirmDialogIsOpen}
                        onDismiss={this.dismissConfirmDialog}
                        dialogContentProps={this.state.confirmDialogContentProps}>

                        {this.state.confirmDialogContentProps.children &&
                            this.state.confirmDialogContentProps.children
                        }

                        <DialogFooter>
                            <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                            <DefaultButton onClick={() => this.state.confirmDialogDismissFunction()} text="Annulla" />
                        </DialogFooter>

                    </Dialog>

                    <Dialog
                        hidden={!this.state.selectUorDialogIsOpen}
                        onDismiss={this.dismissSelectUorDialog}
                        dialogContentProps={{
                            type: DialogType.largeHeader,
                            title: 'Seleziona una UOR',
                            subText: 'Con quale UOR vuoi accedere al protocollo?',

                        }}
                        modalProps={modalProps}

                    >
                        <div className={`position-relative my-scroll-div`}>

                            <ChoiceGroup
                                componentRef={this.choiceGroupRef}

                                defaultSelectedKey={'0'}
                                options={this.state.selectUorChoiceGroupOptions}
                            />
                        </div>

                        <DialogFooter>
                            <PrimaryButton
                                onClick={this.onSelectUorConfirmDialogSubmit}
                                text="Conferma"
                            />
                            <DefaultButton onClick={this.dismissSelectUorDialog} text="Annulla" />
                        </DialogFooter>
                    </Dialog>

                    <input
                        ref={this.uploadInputRef}
                        type="file"
                        style={{ display: "none" }}
                        onChange={(e) => this.onInputFileChange(e.target.files)}
                        multiple={true}
                        accept=".pdf,.docx"
                    />
                </div>

            </React.Fragment>

        );
    }
}

export default connector(withRouter(checkRoles(ProtocolViewer, RoleContext.Uor)));

